import StepImage from './StepImage';

export default StepImage;